import React from 'react';


interface ChatHeaderProps {
  onMenuClick: () => void;
  onSettingsClick: () => void;
  isOnline?: boolean;
  languageMode?: 'traditional' | 'modern';
  onLanguageModeChange?: (mode: 'traditional' | 'modern') => void;
}

const ChatHeader = ({
  onMenuClick,
  onSettingsClick,
  isOnline = true,
  languageMode,
  onLanguageModeChange,
}: ChatHeaderProps) => {
  return (
    <header className="flex items-center justify-between px-4 py-3 bg-background/80 backdrop-blur-md border-b border-border sticky top-0 z-10">
      <div className="flex items-center gap-3">
        <div className="flex flex-col">
          <h1 className="font-serif text-lg leading-tight text-foreground">Stillpoint | htop for the mind</h1>
          <div className="flex items-center gap-1.5">
            <div className={`w-2 h-2 rounded-full ${isOnline ? 'bg-emerald-500' : 'bg-amber-500'}`} />
            <span className="text-xs font-medium text-muted-foreground">
              {isOnline ? 'Online' : 'Connecting...'}
            </span>
          </div>
        </div>
      </div>

      <div className="flex items-center gap-2">
        {/* Snapshot button removed - now in MessageInput */}
      </div>
    </header>
  );
};

export default ChatHeader;